import * as Sentry from '@sentry/vue';
import api from '@/utils/api';

export default {
  namespaced: true,
  state: {
    hasUserBeenLoaded: false,
    data: null,
    environment: 'live',
  },
  getters: {
    isLoggedIn: (state) => !!state.data?.user || false,
    hasTeam: (state) => !!state.data?.currentTeam || false,
    data: (state) => state.data,
    user: (state) => state.data.user,
    name: (state) => state.data.user.name,
    firstName: (state) => state.data.user.name.split(' ')[0] ?? state.data.user.name,
    isSparkStaff: (state) => state.data?.user?.is_spark_staff || false,
    email: (state) => state.data.user.email,
    acronymName: (state) => state.data.user.name.match(/\b\w/g)
      ?.join('')
      .toUpperCase()
      .substring(0, 2),
    siteName: (state) => state.data.currentTeam.name,
    acronymSiteName: (state) => state.data.currentTeam.name.match(/\b\w/g)
      ?.join('')
      .toUpperCase()
      .substring(0, 2),
    availableTeams: (state) => state.data?.availableTeams || [],
    site: (state) => state.data.currentTeam,
    team: (state) => state.data.currentTeam,
    isAdvancedFeaturesEnabled:
      (state) => state.data.currentTeam?.billing_plan_data?.advanced_features_enabled || false,
    isPartner: (state) => state.data.currentTeam?.is_partner,
    plan: (state) => state.data.currentTeam.shopify_recurring_plan,
    isLive: (state) => state.environment === 'live',
    environment: (state) => state.environment,
  },
  mutations: {
    logout(state) {
      state.data = null;
      state.hasUserBeenLoaded = false;
    },
    setData(state, payload) {
      state.data = payload;
      state.hasUserBeenLoaded = true;
    },
    switchEnvironment(state) {
      state.environment = state.environment === 'live' ? 'test' : 'live';
    },
  },
  actions: {
    async loadUser({
      commit,
      state,
      dispatch,
    }, payload) {
      if (!payload && state.hasUserBeenLoaded) {
        return;
      }
      try {
        const { data } = await api.get('/user');
        commit('setData', data);
        if (data.currentTeam) {
          if (data.currentTeam.slugged_name) {
            Sentry.setTag('site-id', data.currentTeam.slugged_name);
          }

          dispatch(
            'env/loadEnvironment',
            data.currentTeam?.is_partner ? 'test' : 'live', // For partners, force using test mode!
            { root: true },
          );
        }
        if (data?.intercomOptions && !(data?.user?.is_spark_staff)) {
          window.Intercom('boot', data.intercomOptions);
        }
      } catch (error) {
        console.error(error);
        commit('setData', null);
        throw new Error(error);
      }
    },
    async logout({ commit }) {
      try {
        await api.post('/logout');
      } catch (error) {
        console.error(error);
      }

      commit('logout');
    },
    switchEnvironment({ commit }) {
      commit('switchEnvironment');
    },
    async changeSite({ dispatch }, payload) {
      try {
        await api.post('/change-site', { team_id: payload.teamId });
      } catch (e) {
        if (e?.response?.status === 404) {
          return false;
        }
        throw e;
      }
      await dispatch('auth/loadUser', true);
      return true;
    },
  },
};
